export enum EnumEtatOffre {
	EN_COURS = 1,
	VALIDEE = 2,
	COMMANDEE = 3,
	PERDUE = 4,
	CLOTUREE = 5,
	A_VALIDER = 6,
	REFUSEE = 7
}
